export default {
  'ja': {
    'user_list': {
      'employee': '社員',
      'retiree': '退職者',
      'label': {
        'user_no': '社員ID',
        'user_name': '社員名',
        'shop_name': '店舗名',
        'age': '年齢',
        'user_type': '役職',
        'joined_date': '入社日',
        'change_date': '役職異動日',
        'overed_date': '退職日'
      }
    },
    'shop_list': {
      'responsible_person': '店舗',
      'label': {
        'shop_name': '店舗名',
        'address': '住所',
        'tel': '電話番号'
      }
    },
    'user_change_list': {
      'change': '役職異動日',
      'label': {
        'user_no': '社員ID',
        'user_name': '社員名',
        'shop_name': '店舗名',
        'age': '年齢',
        'user_type': '役職',
        'change_date': '役職異動日'
      }
    },
    'user_photo_list': {
      'photo': '写真'
    },
    'usertype': {
      'list': {
        'Name': '役職名',
        'Default': '権限',
        'Priority': '表示優先度',
        'Employee': '社員区分'
      },
      'type1': 'システム管理者',
      'type2': '店舗管理者以上',
      'type3': '自店入力者',
      'type4': '自店閲覧者',
      'employee': '社員',
      'not_employee': '社員外'
    },
    'turnover_class': {
      'class1': '自己都合',
      'class2': '契約満了',
      'class3': '定年退職',
      'class4': '解雇',
      'class5': '死亡',
      'class6': 'その他'
    },
    'domain': {
      'list': {
        'No': 'ドメインNo',
        'Name': 'ドメイン名',
        'Content': 'ドメイン内容'
      }
    },
    'businesstype': {
      'list': {
        'Work': '役職名',
        'Detail': '業務内容'
      }
    },
    'turnover': {
      'list': {
        'Group': '離職区分',
        'Content': '離職事由'
      }
    },
    'join': {
      'list': {
        'Class': '入社経緯'
      }
    },
    'unit': {
      'minute': '分',
      'hour': '時間',
      'day': '日'
    },
    'friend_now_job': {
      'expert_school_student': '専門学生',
      'university_student': '大学生',
      'freeter': 'フリーター',
      'housewife': '主婦',
      'office_worker': '会社員',
      'other': 'その他'
    },
    'login': {
      'forgot_password': 'パスワードを忘れた時はこちら',
      'forgot_password_note': '（パスワードのリセット）'
    },
    'forgot_password': {
      'input_email': 'メールアドレスを入力してください',
      'send_reset_email': 'パスワードをリセットするためのリンクが含まれているメールが入力したメールアドレスへ送信されます。',
      'not_reset': 'パスワードをリセットせずに',
      'back_to_login': 'ログインはこちらから',
      'completed': 'パスワードをリセットするためのメールをお送りさせていただきました。',
      'title': 'パスワードを忘れた時は',
      'subtitle': '（パスワードをリセットします）',
      'note_1': 'ご自身のメールアドレスを入力してください。',
      'note_2': 'パスワードをリセットするための',
      'note_3': 'メールをお送りさせていただきます。',
      'send': '送信する'
    },
    'reset_password': {
      'input_new_password': '新しいパスワードを',
      'input_new_password_input': '入力してください',
      'reset_cancel': {
        'message1': 'パスワードをリセットせずに',
        'message2': 'ログインはこちらから'
      },
      'send': '新しいパスワードにする',
      'completed': 'パスワードがリセットされました。'
    },
    'Home': 'ホーム',
    'User Shop': '社員・店舗',
    'User': '社員',
    'User List': '社員一覧',
    'User Detail': '社員詳細',
    'User New': '社員新規登録',
    'User Edit': '社員編集',
    'User Over': '離職登録',
    'User History': '履歴確認',
    'Shop History': '店舗異動',
    'Usertype History': '役職異動',
    'Retiree List': '退職者一覧',
    'User Change List': '役職異動日一覧',
    'Master Manage': 'マスタ管理',
    'ACCESS': 'ACCESS連携',
    'User Type': '役職',
    'User Type List': '役職一覧',
    'User Type New': '役職新規登録',
    'User Type Detail': '役職詳細',
    'User Type Edit': '役職編集',
    'Domain Type': 'ドメイン',
    'Domain Type List': 'ドメイン一覧',
    'Domain Type New': 'ドメイン新規登録',
    'Domain Type Detail': 'ドメイン詳細',
    'Domain Type Edit': 'ドメイン編集',
    'Turnover Type': '離職事由',
    'Turnover Type List': '離職事由一覧',
    'Turnover Type New': '離職事由新規登録',
    'Turnover Type Detail': '離職事由詳細',
    'Turnover Type Edit': '離職事由編集',
    'Business Type': '業務内容',
    'Business Type List': '業務内容一覧',
    'Business Type New': '業務内容新規登録',
    'Business Type Detail': '業務内容詳細',
    'Business Type Edit': '業務内容編集',
    'Join Type': '入社経緯',
    'Join Type List': '入社経緯一覧',
    'Join Type New': '入社経緯新規登録',
    'Join Type Detail': '入社経緯詳細',
    'Join Type Edit': '入社経緯編集',
    'Shop': '店舗',
    'Shop List': '店舗一覧',
    'Shop New': '店舗新規登録',
    'Shop Detail': '店舗詳細',
    'Shop Edit': '店舗編集',
    'My Profile': 'マイページ',
    'Moral Check': 'モラル確認',
    'Login': 'ログイン',
    'Login Title': 'ログイン画面',
    'Login Button': 'ログインする',
    'Logout': 'ログアウト',
    'Read More': 'さらに読み込む',
    'Read All': 'すべて見る',
    'Close': '閉じる',
    'age': '{age}歳',
    'New Registration': '新規登録',
    'Print': '名簿一覧印刷',
    'Back': '戻る',
    'Show': '表示',
    'Edit': '編集',
    'Save': '保存',
    'Delete': '削除',
    'Register': '登録',
    'Cancel': 'キャンセル',
    'Login ID': 'ID',
    'Password': 'パスワード',
    'Need to login': 'ログインしてください。',
    'No Data': 'データがありません。',
    'Delete Confirm': '削除してよろしいですか？',
    'Update Successful': '正常に更新されました。',
    'Avatar Upload Successful': '写真をアップロードしました。',
    'Mail Address': 'メールアドレス',
    'Current Password': '現在のパスワード',
    'New Password': '新しいパスワード',
    'New Password Retyped': '新しいパスワード(確認)',
    'Password Reset': 'パスワードリセット',
    'Reset': 'リセット',
    'Send': '送信',
    'Image Upload Message': 'ここにファイルをドロップしてください',
    'Image Upload Successful': 'ファイルをアップロードしました。',
    'validations': {
      'required': '必須項目です。',
      'password_confirmation': '同じパスワードを入力してください。',
      'invalid_furigana': 'ひらがなを入力してください。',
      'invalid_number': '半角数字で入力してください。',
      'not_hyphen': '「-」なしで入力してください',
      'fomat_tel': '電話番号形式で入力してください',
      'fomat_fax': 'FAX番号形式で入力してください',
      'before_today': '本日以前を入力して下さい。',
      'after_release': '2017年12月1日以降を入力して下さい。'
    },
    'Maintenance': 'メンテナンス中です。しばらくお待ちください。',
    'user': {
      'remove_success_message': '名簿を削除しました。'
    },
    'Company Name': 'タイラベストビート',
    'SNS Title': '社内SNS',
    'Guidance': {
      'Moral_title': 'モラル確認の手引き',
      'Title_1': '■反社会的行動',
      'Title_2': '■自己管理',
      'Title_3': '■就業規則確認',
      'Title_4': '■採用時確認事項',
      'Title_5': '■就業規則 ・法令遵守',
      'Title_6': '■社員間トラブル',
      'Title_7': '■対人マナー',
      'Title_8': '■未成年質問',
      'Title_9': '■モラル行動確認',
      'Title_10': '■入寮者質問',
      'Title_11': '■職場環境',
      'Title_12': '■企業コンプライアンス',
      'Title_13': '■知識確認',
      'Title_14': '■モラル行動確認',
      'Title_15': '■ルール行動確認',
      'Title_16': '■確認意識',
      'Title_17': '■モラル他者視点',
      'Title_18': '■ESmyカード',
      'Title_19': '■憂慮の有無',
      'Sentence_1': '① 道路交通法違反',
      'Sentence_1_1': 'Yes We Can P:77 『社員規定』参照',
      'Sentence_2': '② 迷惑防止条例違反・強制',
      'Sentence_2_1': '　わいせつ罪(痴漢行為・盗撮行為)',
      'Sentence_3': '③ 窃盗罪・恐喝罪',
      'Sentence_3_1': '(罪のケースで第条は異なります。)',
      'Sentence_4': '④',
      'Sentence_4_1': 'Yes We Can P:60 【知っておきたい法規】参照',
      'Sentence_5': '⑤',
      'Sentence_5_1': '役職者手帳P:100参照',
      'Sentence_5_2': 'Yes We Can P:70～72参照',
      'Sentence_5_3': '採用時確認事項/雇用期間遵守事項',
      'Sentence_6': '⑥ 予防保全として勤務への支障対策を施せる能力がある事！',
      'Sentence_7': '⑦⑧ 就業規則',
      'Sentence_7_1': 'Yes We Can P:77『社員規定』参照',
      'Sentence_7_2': '・採用時説明事項',
      'Sentence_8': '⑨ 雇用期間遵守事項',
      'Sentence_8_1': '　・就業規則確認',
      'Sentence_9': '⑩ 風俗営業における確認事項',
      'Sentence_9_1': '　・社員間トラブル',
      'Sentence_10': '⑪',
      'Sentence_10_1': 'Yes We Can P:77『社員規定』参照',
      'Sentence_11': '⑫',
      'Sentence_11_1': 'Yes We Can P:77『社員規定』参照',
      'Sentence_11_2': '社会的には、恋愛は自由です。しかし、社内恋愛による２人の行動が社の風紀をはじめとした店舗内に齎らす負の影響を考えて頂ければ幸いです。また、恋愛関係になった場合には、所属長への報告を行い、誠実な交際をお願いします。',
      'Sentence_12': '⑬ セクシャルハラスメント：',
      'Sentence_12_1': '「労働者」の意に反する「性的言動」 （男女雇用機会均等法）',
      'Sentence_13': '⑬ パワーハラスメント：',
      'Sentence_13_1': '職務上の地位や人間関係の優位性を背景に適正な業務範囲を超えて精神・身体的苦痛を与える又は、職場環境に悪影響を与え環境を悪化させる行為。ハラスメント行為(パワハラ、セクハラ、モラハラ等、様々な場面においての嫌がらせ、いじめ。)',
      'Sentence_14': '⑭ 未成年飲酒禁止法・未成年喫煙禁止法　(2000年改正)罰金：',
      'Sentence_14_1': '高額化・責任の拡大',
      'Sentence_15': '⑮',
      'Sentence_15_1': 'Yes We Can P:76『寮則』参照',
      'Sentence_16': '⑯',
      'Sentence_16_1': 'Yes We Can P:76『寮則』参照',
      'Sentence_17': '⑰ 利用マナーが確立されており整理整頓清掃が行渡っており気持ちよく利用出来る。全ての社員が快適な休憩スペースであること。',
      'Sentence_18': '⑱ 上司と部下の関係において報告・連絡・相談を気軽に出来る環境が望ましく、すなわち風通し良い職場であること。',
      'Sentence_19': '⑲ 社員間において、チーム力向上に支障など発生する事なく　団結心の和が煌く環境であること。',
      'Sentence_20': '⑳ 遵法営業に伴う正しい知識と認識が必要となります。',
      'Sentence_20_1': 'お客様目線ではいけません！',
      'Sentence_20_2': '※お客様に提供する賞品は、原則すべて等価となります。',
      'Sentence_21': '㉑ お客様へのサービス業での営業ですが、店舗運営を行う上では、法令遵守があってこその営業となります！',
      'Sentence_21_1': '※①パチンコ店(風営法第4号営業)では、現金への買取を推奨する事が出来ませんので買取所への御案内を控えております。',
      'Sentence_21_2': '※②買取業務は、一切関わりがありません。Yes We Can P:75 『3店方式』　「他のお客様はあちらの方へ行かれてるみたいですが…？」',
      'Sentence_22': '㉒ 安心安全の観点からの防災防火意識　電気火災時には、二酸化炭素消火器を使用します。',
      'Sentence_22_1': '保管場所は、ホールカウンターです。',
      'Sentence_23': '㉓ AEDとは自動体外式除細動器の略でお客様が、突然心臓が正常に拍動できなくなった心停止状態の心臓に対して、電気ショックを行い、心臓を正常なリズムに戻すための医療機器です。',
      'Sentence_24': '㉔ 我々の社業は接客業であり不特定多数のお客様に認知されております。よって集団行動となると認知の度合いが倍増し行動に自制心の要求が個人より大きく求められるケースがあるからです。',
      'Sentence_25': '㉕ ソーシャルメディアは、多くの情報を入手し、コミュニティを形成するには有効ですが、匿名性が高いことから安易な配信をし大きなトラブルを引き起こすこともあります。',
      'Sentence_25_1': '利用に関しては、十分注意して行って下さい。軽率な利用や影響力を理解していること。',
      'Sentence_26': '㉖ セキュリティー及びコンプライアンスの観点から勤務中の携帯電話(スマフォ等)の利用をお断りしております。',
      'Sentence_27': '㉗ 社業は、公平平等を期す業態で情報漏洩や勘違い等を引き起こす原因とみなします。',
      'Sentence_28': '㉘ いまいちど再確認し、意識しておく事項となります。(免許未取得者は、質問内容に対して理解の観点で応じてください。)',
      'Sentence_29': '㉙ ワンダーランドびとの仲間を大事にすることは正しい事であるが、倫理的観点や正義を優先させる事が最重要です。',
      'Sentence_30': '㉚ 業務内外を問わず、組織人として倫理意識(人として守るべき道。道徳)を持ち社会生活を過ごすことが出来ている事が望ましい。',
      'Sentence_31': '㉛毎年1月11日熱豊会にて「`ｇｏｏｄ`のあるＥＸ-Ｃｏｍｐａｎｙ」を実現する為に掲げるＷＩＬＬ（私が描く今年の抱負)とＭＵＳＴ（私が求められている事）を、',
      'Sentence_31_1': 'エージェントカードに貼付けます。ＷＩＬＬ＆ＭＵＳＴの未記入による作成漏れを防ぎ、いつでも振り返りを行える環境を作ります。',
      'Sentence_32': '㉜人間関係などで悩む事も多々あり　出来たら異動転勤して向上心を活性させたいと考える事が頻繁にある方は、“いいえ”にチェックと在籍期間を記入して下さい',
      'Sentence_33': '類似行為や擬似行為についても、自身がもたらす行動による場合もあります。再度、自分自身の行動は、誠実に責任ある行動でお願いします。',
      'Sentence_33_1': '上記、事項の中でも反社会的行動には厳しい処分（法的）があると自覚しておいて下さい。',
      'Sentence_34': '※虚偽の報告に関しても「誠実性に欠け、信頼できない」と判断した場合は、所属長の面談を実施します。  c'
    }
  }
}



// WEBPACK FOOTER //
// ./src/i18n.js